import $ from "jquery";

export const initMenuOverlay = () => {
    $(function () {
        var CONTENT_ELEMENT = "#content";
        var MENU_TRIGGER_ELEMENT = ".main-menu-trigger";
        var MENU_CLOSE_ELEMENT = ".main-menu-close";
        var MENU_CONTAINER_ELEMENT = ".main-menu-container";
        var MENU_WRAPPER_ELEMENT = ".main-menu-wrapper";

        function toggleMenuVisibility() {
            $([MENU_TRIGGER_ELEMENT, MENU_CLOSE_ELEMENT, MENU_CONTAINER_ELEMENT].join(","))
                .toggleClass("visible");
                $(CONTENT_ELEMENT).toggleClass("blur");
                $(MENU_WRAPPER_ELEMENT).toggleClass("hidden");
                $("body").toggleClass("main-menu-visible");
        }

        function openMenu() {
            toggleMenuVisibility();
            var items;
            if (window.innerWidth > 1024) {
                //DESKTOP
                items = $(".main-menu .menu-item a");
            } else {
                // MOBILE
                items = $(".primary .menu-item a");
            }
            //Fokusiere ertsen link im Menu:
            items[0].focus();
        }
        function closeMenu() {
            toggleMenuVisibility();
        }
        $([MENU_TRIGGER_ELEMENT].join(",")).on("click", function(e) {
            openMenu();
        });
        $([MENU_CLOSE_ELEMENT].join(",")).on("click", function(e) {
            closeMenu();
        });


        var previousWidth;
        function rebuildMenu() {
            // only apply changes if switched from mobile and desktop and vice versa
            if(window.innerWidth > 1024 && !(previousWidth > 1024)) {
                // DESKTOP

                //note to set sub-visible class on right-menu later
                var isSubVisible = $(".main-menu-container .main-menu .primary .sub.sub-studierende").hasClass("visible") || $(".main-menu-container .main-menu .primary .sub.sub-lehrende").hasClass("visible");

                // restructure to left menu
                $("<div class=\"left-menu\"></div>").appendTo(".main-menu-container .main-menu");
                $(".main-menu-container .main-menu .header .header-icon").detach().appendTo(".main-menu-container .main-menu .left-menu");
                // hide svg chevrons
                $(".main-menu-container .main-menu .primary svg").addClass("hidden");
                $(".main-menu-container .main-menu .primary").removeClass("primary").addClass("top").detach().appendTo(".main-menu-container .main-menu .left-menu");
                $(".main-menu-container .main-menu .secondary").not(".social").removeClass("secondary").addClass("bottom").detach().appendTo(".main-menu-container .main-menu .left-menu");

                //restructure to right menu
                $("<div class=\"right-menu\"></div>").appendTo(".main-menu-container .main-menu");
                if(isSubVisible) {
                    $(".main-menu-container .main-menu .right-menu").addClass("sub-visible");
                }

                $(".main-menu-container .main-menu .header .header-menu").detach().appendTo(".main-menu-container .main-menu .right-menu");
                $(".main-menu-container .main-menu .sub").detach().removeClass("sub").addClass("top").appendTo(".main-menu-container .main-menu .right-menu");
                $(".main-menu-container .main-menu .secondary.social").removeClass("secondary social").addClass("bottom").detach().appendTo(".main-menu-container .main-menu .right-menu");




                //restore menu
                $(".main-menu-container .main-menu .right-menu .header-menu .menu-items .menu-item.search").removeClass("hidden");
                $(".main-menu-container .main-menu .right-menu .header-menu .menu-items .menu-item.settings").removeClass("hidden");
                $(".main-menu-container .main-menu .right-menu .header-menu .menu-items .menu-item.loginout").removeClass("hidden");
                $(".page .header .header-menu .menu-items .menu-item.search").removeClass("hidden");
                $(".page .header .header-menu .menu-items .menu-item.loginout").removeClass("hidden");

                //cleanup
                $(".main-menu-container .header").remove();

                //click handlers
                $(".main-menu-container .main-menu .left-menu .menu-item").click(function() {
                    $(".main-menu .menu-item").removeClass("active")
                    $(this).toggleClass("active");
                });
                $(".main-menu-container .main-menu .left-menu .top .menu-item.item-studierende").click(function() {
                    $(".main-menu-container .main-menu .right-menu .top").removeClass("visible");
                    $(".main-menu-container .main-menu .right-menu").removeClass("sub-visible");
                    $(".main-menu-container .main-menu .right-menu .top.sub-studierende").toggleClass("visible");
                    $(".main-menu-container .main-menu .right-menu").toggleClass("sub-visible");
                    $(".main-menu-container").addClass("split");
                    $(".main-menu-wrapper").removeClass("main-menu-wrapper-tr-navy").addClass("main-menu-wrapper-white");
                });
                $(".main-menu-container .main-menu .left-menu .top .menu-item.item-lehrende").click(function() {
                    $(".main-menu-container .main-menu .right-menu .top").removeClass("visible");
                    $(".main-menu-container .main-menu .right-menu").removeClass("sub-visible");
                    $(".main-menu-container .main-menu .right-menu .top.sub-lehrende").toggleClass("visible");
                    $(".main-menu-container .main-menu .right-menu").toggleClass("sub-visible");
                    $(".main-menu-container").addClass("split");
                    $(".main-menu-wrapper").removeClass("main-menu-wrapper-tr-navy").addClass("main-menu-wrapper-white");
                });
                $(".main-menu-container .main-menu .left-menu .top .menu-item.item-themenwelten").click(function() {
                    $(".main-menu-container .main-menu .right-menu .top").removeClass("visible");
                    $(".main-menu-container .main-menu .right-menu").removeClass("sub-visible");
                    $(".main-menu-container .main-menu .right-menu .top.sub-themenwelten").toggleClass("visible");
                    $(".main-menu-container .main-menu .right-menu").toggleClass("sub-visible");
                    $(".main-menu-container").addClass("split");
                    $(".main-menu-wrapper").removeClass("main-menu-wrapper-tr-navy").addClass("main-menu-wrapper-white");
                });
                $(".main-menu-container .main-menu .left-menu .top .menu-item.item-ueber-uns").click(function() {
                    $(".main-menu-container .main-menu .right-menu .top").removeClass("visible");
                    $(".main-menu-container .main-menu .right-menu").removeClass("sub-visible");
                    $(".main-menu-container .main-menu .right-menu .top.sub-ueber-uns").toggleClass("visible");
                    $(".main-menu-container .main-menu .right-menu").toggleClass("sub-visible");
                    $(".main-menu-container").addClass("split");
                    $(".main-menu-wrapper").removeClass("main-menu-wrapper-tr-navy").addClass("main-menu-wrapper-white");
                });
            } else if(window.innerWidth <= 1024 && !(previousWidth <= 1024)){
                // MOBILE

                // add header
                $("<div class=\"header\"></div>").appendTo(".main-menu-container .main-menu");
                $(".main-menu-container .main-menu .left-menu .header-icon").detach().appendTo(".main-menu-container .main-menu .header");
                $(".main-menu-container .main-menu .right-menu .header-menu").detach().appendTo(".main-menu-container .main-menu .header");

                //add primary
                $(".main-menu-container .main-menu .left-menu .top").removeClass("top").addClass("primary").detach().appendTo(".main-menu-container .main-menu");
                //show svg chevrons
                $(".main-menu-container .main-menu .primary svg").removeClass("hidden");

                //add secondaries
                $(".main-menu-container .main-menu .left-menu .bottom").removeClass("bottom").addClass("secondary").detach().appendTo(".main-menu-container .main-menu");
                $(".main-menu-container .main-menu .right-menu .top").removeClass("top").addClass("sub");
                $(".main-menu-container .main-menu .right-menu .sub.sub-studierende").detach().appendTo(".main-menu-container .main-menu .primary .menu-item.item-studierende");
                $(".main-menu-container .main-menu .right-menu .sub.sub-lehrende").detach().appendTo(".main-menu-container .main-menu .primary .menu-item.item-lehrende");
                $(".main-menu-container .main-menu .right-menu .sub.sub-themenwelten").detach().appendTo(".main-menu-container .main-menu .primary .menu-item.item-themenwelten");
                $(".main-menu-container .main-menu .right-menu .bottom").removeClass("bottom").addClass("secondary social").detach().appendTo(".main-menu-container .main-menu");

                //hide menu items
                $(".main-menu-container .main-menu .header .header-menu .menu-items .menu-item.search").addClass("hidden");
                $(".main-menu-container .main-menu .header .header-menu .menu-items .menu-item.settings").addClass("hidden");
                $(".page .header .header-menu .menu-items .menu-item.search").addClass("hidden");

                //cleanup
                $(".main-menu-container .main-menu .left-menu").remove();
                $(".main-menu-container .main-menu .right-menu").remove();

                // click handlers
                $(".main-menu-container .main-menu .primary .menu-item").click(function() {
                    $(".main-menu-container .main-menu .menu-item").removeClass("active")
                    $(this).toggleClass("active");
                });
                $(".main-menu-container .main-menu .primary .menu-item.item-studierende").click(function() {
                    $(".main-menu-container .main-menu .primary .sub").removeClass("visible");
                    $(".main-menu-container .main-menu .primary .sub.sub-studierende").toggleClass("visible");
                });
                $(".main-menu-container .main-menu .primary .menu-item.item-lehrende").click(function() {
                    $(".main-menu-container .main-menu .primary .sub").removeClass("visible");
                    $(".main-menu-container .main-menu .primary .sub.sub-lehrende").toggleClass("visible");
                });
                $(".main-menu-container .main-menu .primary .menu-item.item-themenwelten").click(function() {
                    $(".main-menu-container .main-menu .primary .sub").removeClass("visible");
                    $(".main-menu-container .main-menu .primary .sub.sub-themenwelten").toggleClass("visible");
                });
                $(".main-menu-container .main-menu .primary .menu-item.item-ueber-uns").click(function() {
                    $(".main-menu-container .main-menu .primary .sub").removeClass("visible");
                    $(".main-menu-container .main-menu .primary .sub.sub-ueber-uns").toggleClass("visible");
                });
                $(".main-menu-wrapper").removeClass("main-menu-wrapper-white").addClass("main-menu-wrapper-tr-navy");


            }
            previousWidth = window.innerWidth;
        }

        window.addEventListener("resize", rebuildMenu);

        //initial check
        rebuildMenu();
    });
};
